module.exports = __webpack_public_path__ + "ab1cc8526e65c242345479c544b1caac.png";